/**
 * IDs of `Dialog` components (used for aria props).
 */
export const dialogElementIDs = {
  title: "dialog-title",
  message: "dialog-message",
} as const;
